import { createContext, useContext } from "react";

export type ConversationControl = {
  startNewConversation: () => void;
};

export const ConversationControlContext = createContext<ConversationControl | null>(null);

export function useConversationControl(): ConversationControl {
  const ctx = useContext(ConversationControlContext);
  if (!ctx) {
    throw new Error("useConversationControl must be used within ApiRuntimeProvider");
  }
  return ctx;
}
